import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputAdornment, Pagination, Paper, Snackbar, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useAllBusinessAssociatePaymentListMutation } from "../../redux/Payments/Payments.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLocation, useNavigate } from "react-router-dom";
import SearchIconLg from "../../assets/Icons/SearchIcon";


const Payments = () => {

    const [value, setValue] = useState('1');
    const navigate = useNavigate()
    const location = useLocation()
    const pathName = location?.pathname

    const [openViewPaymentHistory, setOpenViewPaymentHistory] = useState(false)
    const [tableLoader, setTableLoader] = useState(false)
    const [paymentList, setPaymentList] = useState([])

    const [page, setPage] = useState(+localStorage.getItem("paymentsNewPage") || 1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchPaymentByRecruiter, setSearchPaymentByRecrutier] = useState("")
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const { Snackbar } = useContext(SnackbarContext)
    const [getAllPaymentList] = useAllBusinessAssociatePaymentListMutation()

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Pagination Functionalities
    const handleChangePage = (e, newPage) => {
        localStorage.setItem("paymentsNewPage", newPage)
        setPage(newPage)
    }

    const handleOpenPaymentDialog = (data) => {
        navigate('/payment-history', {
            state: {
                recruiterFullName: data?.recruiterFullName, recruiterId: data?.recruiterId, recruiterEmail: data?.recruiterEmail,
                recruiterBankName: data?.recruiterBankName, recruiterBranchName: data?.recruiterBranchName, recruiterAccountNumber: data?.recruiterAccountNumber,
                recruiterIfscCode: data?.recruiterIfscCode, pathName: pathName
            }
        })
    }

    const handleClose = () => {
        setOpenViewPaymentHistory(false)
    }

    const handleSearchPaymnet = (e) => {
        setSearchPaymentByRecrutier(e.target.value)
        setPage(1)
    }

    const getPaymentDetails = async () => {
        try {
            const payload = {
                page: page - 1,
                size: 10,
                recruiterName: debouncedSearch,
            }
            setTableLoader(true)
            const response = await getAllPaymentList(payload).unwrap()
            setTableLoader(false)
            setPaymentList(response?.response?.referralCommissionDetails)
            setTotalDataCount(response?.response?.totalElements)

        } catch (error) {
            Snackbar("Network error", 'error')
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchPaymentByRecruiter)
        }, 500);
        return () => {
            clearTimeout(handler)
        }
    }, [searchPaymentByRecruiter])

    useEffect(() => {
        getPaymentDetails()
    }, [page, debouncedSearch])

    return (
        <Box className="container">
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography className="title">Payment Screen</Typography>
                <TextField
                    placeholder="Search by BA name"
                    className="textfields1"
                    value={searchPaymentByRecruiter}
                    onChange={handleSearchPaymnet}
                    sx={{
                        "& input": {
                            fontSize: "14px",
                            padding: "6px 8px",
                        },
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "px",
                        },
                        width: '25%'
                    }}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start" sx={{ marginRight: "5px" }}>
                                    <SearchIconLg width={20} height={20} />
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </Box>

            <Box sx={{ width: '100%', typography: 'body2', marginTop: '20px' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="Business Associate Payments"
                            textColor="primary"
                            indicatorColor="secondary"
                        >
                            <Tab
                                label="Payments"
                                value="1"
                                className="tabs"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: value === "1" ? 'bold' : 'normal',
                                    transition: 'all 0.3s ease',
                                }}
                            />
                        </TabList>
                    </Box>

                    <TabPanel value="1" sx={{ display: 'flex', padding: 1.5 }}>
                        <Paper sx={{ width: '100%', overflow: 'auto', marginTop: '10px', border: '1px solid #E9EAEB' }} elevation={0}>
                            <Table>
                                <TableHead className="tableHeadersCell">
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">Business Associate</TableCell>
                                        <TableCell className="tableHeadersCell">Account Details</TableCell>
                                        <TableCell className="tableHeadersCell">No.of.Job</TableCell>
                                        <TableCell className="tableHeadersCell">No.of.Candidates</TableCell>
                                        <TableCell className="tableHeadersCell">No.of.Clients</TableCell>
                                        <TableCell className="tableHeadersCell">Total Earnings</TableCell>
                                        {/* <TableCell className="tableHeadersCell">Paid Amount</TableCell>
                                        <TableCell className="tableHeadersCell">Refund Amount</TableCell> */}
                                        <TableCell className="tableHeadersCell">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    !tableLoader ? (
                                        paymentList?.length > 0 ? (
                                            <TableBody>
                                                {
                                                    paymentList?.map((data, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterId} {data?.recruiterFullName}<br></br> {data?.recruiterEmail}</TableCell>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterBankName} {data?.recruiterBranchName}<br></br>{data?.recruiterAccountNumber}<br></br>{data?.recruiterIfscCode}</TableCell>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterNoOfPositionCount}</TableCell>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterNoOfCandidateCount}</TableCell>
                                                            <TableCell className="tableBodyCell">{data?.recruiterNoOfClientCount}</TableCell>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterTotalEarnings}</TableCell>
                                                            {/* <TableCell className="tableBodyCell" >{data?.recruiterPaidAmount}</TableCell>
                                                            <TableCell className="tableBodyCell" >{data?.recruiterRefundAmount}</TableCell> */}
                                                            <TableCell className="tableBodyCell" onClick={() => handleOpenPaymentDialog(data)} sx={{ color: '#6941C6', fontWeight: 'bold', cursor: 'pointer' }}>view</TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    ) : (<TableRow>
                                        <TableCell colSpan={8}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>)
                                }
                                {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                                    <TableRow>
                                        <TableCell colSpan={100}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    disabled={page === 1}
                                                    sx={{ height: '36px' }}
                                                />

                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(totalDataCount / rowsPerPage)}
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    shape="rounded"
                                                    hidePrevButton
                                                    hideNextButton
                                                />

                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                        </Paper>
                    </TabPanel>
                </TabContext>
            </Box>

            <Grid2>
                <Dialog
                    open={openViewPaymentHistory}
                    onClose={handleClose}
                    scroll="paper"
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            minHeight: '70vh',
                            minWidth: '55vw'
                        },
                        marginLeft: '70px'
                    }}
                >
                    <DialogTitle>Payment History</DialogTitle>
                    <DialogContent>

                        <DialogContentText>

                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <MUICancelButton title="Close" onClick={() => setOpenViewPaymentHistory(false)} />
                    </DialogActions>
                </Dialog>
            </Grid2>
        </Box>
    )
}
export default Payments;